import { DatasetMetadataType } from './dataset-metadata-type'

export abstract class ILabelingInfo {
  public type?: DatasetMetadataType
}
